import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  isFeatureEnabled(key: FeatureFlagEnum): boolean {
    if (environment.featureConfig && environment.featureConfig[key]) {
      return Boolean(environment.featureConfig[key]);
    }
    return false;
  }
}
